"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectFilter = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledComponentsBreakpoint = _interopRequireDefault(require("styled-components-breakpoint"));

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var SelectFilter = _styledComponents["default"].div.attrs(function () {
  return {
    className: 'form-group mb-2 mb-lg-0 mr-lg-2'
  };
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    min-width: 200px;\n    width: 100%;\n\n    ", ";\n\n    .list__control {\n        border-radius: 0px;\n        min-height: 36px;\n    }\n\n    .list__dropdown-indicator {\n        padding: 6px 8px;\n    }\n\n    .list__menu {\n        z-index: 100;\n    }\n"])), (0, _styledComponentsBreakpoint["default"])('laptop')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        width: auto;\n    "]))));

exports.SelectFilter = SelectFilter;